import { useMemo } from 'react';
import styles from './wizard-steps.module.scss';
import clsx from 'clsx';

export interface WizardStepsProps {
  totalSteps: number;
  currentStep: number;
  className?: string;
}

export function WizardSteps(props: WizardStepsProps) {
  const steps = useMemo(
    () => Array.from({ length: props.totalSteps }, () => 0),
    [props.totalSteps]
  );

  return (
    <div className={clsx(styles.root, props.className)}>
      {steps.map((step, index) => (
        <div
          key={index}
          className={clsx({
            [styles.step]: true,
            [styles.active]: index + 1 === props.currentStep,
            [styles.completed]: index < props.currentStep,
          })}
        />
      ))}
    </div>
  );
}

export default WizardSteps;
